module.exports = "https://r.nearpod.com/assets/media/image/user_blue_icon-7101e70b4da7cb70579ccb421405ef29.svg";